export default {
  toolbar: {
    position:'absolute', 
    right: 20,
    top: 70,
    zIndex: 1000
  },

  textArea: {
    height: 'calc(100vh - 180px)',
    maxWidth: 1100
  },
  sbaDocument: {
    whiteSpace: 'pre',
    padding: '20px 5px'
  }
}


// WEBPACK FOOTER //
// ./src/sbl/sbl.css.js